export const toFixed5 = (value) => Number(value.toFixed(5));

export const toFixed3 = (value) => Number(value.toFixed(3));

export const toFixed2 = (value) => Number(value.toFixed(2));
